import { render, staticRenderFns } from "./AppointmentClearModal.vue?vue&type=template&id=32ca98d0"
import script from "./AppointmentClearModal.vue?vue&type=script&lang=js"
export * from "./AppointmentClearModal.vue?vue&type=script&lang=js"
import style0 from "./AppointmentClearModal.vue?vue&type=style&index=0&id=32ca98d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports